import BaseModel from './BaseModel'

export default class Inventory extends BaseModel {
  // ... any Inventory-specific methods or overrides ...
}
